import React, { useCallback } from 'react';
import { Tag } from 'antd';
import { Days } from './ACAdvancedCron';

const { CheckableTag } = Tag;

export const daysValues = Days.map(entry => entry.value);

const DayPicker = (props) => {
  const {
    value: formValue = [],
    onChange,
  } = props;

  const handleDaySelection = useCallback((day, checked) => {
    const daySelection = [...formValue];
    if (checked === true) {
      daySelection.push(day);
    } else {
      const spliceIndex = daySelection.indexOf(day);
      daySelection.splice(spliceIndex, 1);
    }
    onChange && onChange(daySelection);
  }, [formValue, onChange]);


  const DaysCheckableTags = Days.map(({ label, value }) => (
    <CheckableTag
      key={`${label}_${value}`}
      checked={formValue.indexOf(value) > -1}
      onChange={checked => handleDaySelection(value, checked)}
      className='runbook-checkable-tags'
    >
      {label}
    </CheckableTag>
  ));

  return DaysCheckableTags;
}

export default DayPicker;

export const cronDaysValidator = () => {
  return {
    validator: (record, value) => {

      const isValidSelection = (Array.isArray(value) && value.length > 0);
      if (isValidSelection) {
        return Promise.resolve();
      }

      return Promise.reject('Please select days');

    }
  }
}
